import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "statistics" };
const _hoisted_2 = {
    key: 0,
    class: "statistics__holder"
};
const _hoisted_3 = { class: "statistics__title" };
const _hoisted_4 = { class: "statistics__content" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "statistics__data"
};
const _hoisted_7 = { class: "stats-item__label" };
const _hoisted_8 = { class: "stats-item__value" };
const _hoisted_9 = {
    key: 1,
    class: "statistics__data"
};
const _hoisted_10 = {
    key: 2,
    class: "statistics__data"
};
import { ref, watch } from 'vue';
import moment from 'moment';
import Icon from "./Icon.vue";
import Spinner from "./Spinner.vue";
import LineChart from "./charts/LineChart.vue";
import PieChart from "./charts/PieChart.vue";
import trans from "../services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableStatistics',
    props: {
        grid: {},
        loader: { type: Function },
        reloadTrigger: {}
    },
    setup(__props) {
        const props = __props;
        const show = ref(false);
        const loading = ref(false);
        const statistics = ref(null);
        watch(() => props.reloadTrigger, () => {
            if (show.value) {
                load();
            }
        }, { deep: true });
        function load() {
            statistics.value = null;
            loading.value = true;
            props.loader()
                .then(data => {
                statistics.value = prepareStatistics(data);
            })
                .finally(() => loading.value = false);
        }
        function toggle() {
            show.value = !show.value;
            if (show.value) {
                load();
            }
        }
        function prepareStatistics(data) {
            const statistics = [];
            data.items.forEach(item => {
                const itemConfig = props.grid.statistics.items
                    .find(c => item.name === c.name);
                const column = props.grid.columns.find(col => col.name === itemConfig.column);
                const chartData = createChartData(item);
                statistics.push({
                    display: true,
                    column,
                    item,
                    chartData,
                });
            });
            return statistics;
        }
        function createChartData(item) {
            const stats = item.data;
            if (item.type === 'terms') {
                const labels = Object.keys(stats.terms);
                const data = labels.map(label => stats.terms[label]);
                if (stats.other_terms) {
                    labels.push(trans('statistics.other_terms'));
                    data.push(stats.other_terms);
                }
                return {
                    labels: labels,
                    datasets: [{
                            data: data,
                        }],
                };
            }
            else if (item.type === 'histogram') {
                const labels = Object.keys(stats.items);
                const data = labels.map(label => stats.items[label]);
                return {
                    labels: labels,
                    datasets: [{
                            label: '',
                            data: data,
                        }],
                };
            }
            else if (item.type === 'date_histogram') {
                const dates = Object.keys(stats.dates);
                const data = dates.map(label => stats.dates[label]);
                const labels = dates
                    .map(date => date.replace(/\.0+Z\[Z]$/, ''))
                    .map(date => {
                    const d = moment(date);
                    if (stats.interval.endsWith('y')) {
                        return d.format('YYYY');
                    }
                    if (stats.interval.endsWith('M')) {
                        return d.format('MMM YYYY');
                    }
                    if (stats.interval.endsWith('h')) {
                        return moment(date).format('DD.MM.YYYY HH:mm');
                    }
                    if (stats.interval.endsWith('m')) {
                        return moment(date).format('DD.MM.YYYY HH:mm');
                    }
                    if (stats.interval.endsWith('s')) {
                        return moment(date).format('HH:mm:ss');
                    }
                    return moment(date).format('DD.MM.YYYY');
                });
                return {
                    labels: labels,
                    datasets: [{
                            label: 'Items',
                            data: data,
                            fill: true,
                            stepped: true,
                        }],
                };
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggle()), ["prevent"])),
                    class: "statistics__toggle",
                    href: "#"
                }, [
                    _createVNode(Icon, { name: "chart-line" })
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (show.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('statistics')), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (statistics.value)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(statistics.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.item.name,
                                        class: "statistics__item"
                                    }, [
                                        _createElementVNode("div", {
                                            onClick: _withModifiers(($event) => (item.display = !item.display), ["prevent"]),
                                            class: "statistics__item-title"
                                        }, _toDisplayString(item.column ? item.column.label : _ctx.$t('statistics.' + item.item.name)), 9, _hoisted_5),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        (item.display)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (item.item.type === 'number_stats')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['min', 'max', 'avg', 'sum'], (stat) => {
                                                            return _createElementVNode("div", {
                                                                class: "stats-item",
                                                                key: stat
                                                            }, [
                                                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('statistics.' + stat)), 1),
                                                                _cache[1] || (_cache[1] = _createTextVNode()),
                                                                _createElementVNode("div", _hoisted_8, _toDisplayString(item.item.data[stat]), 1)
                                                            ]);
                                                        }), 64))
                                                    ]))
                                                    : (item.item.type === 'terms')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                            _createVNode(PieChart, {
                                                                type: "doughnut",
                                                                data: item.chartData
                                                            }, null, 8, ["data"])
                                                        ]))
                                                        : (item.item.type === 'histogram' || item.item.type === 'date_histogram')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                                _createVNode(LineChart, {
                                                                    data: item.chartData
                                                                }, null, 8, ["data"])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
